import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButton: {
    padding: 0,
    marginLeft: 24,
  },
});

export default useStyles;
